import React, { useEffect, useState } from 'react'
import {
    Box,
    Grid,
    IconButton,
    Tooltip,
    Typography
} from "@mui/material";
import TableContainer from '../../../Components/TableContainer/TableContainer';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Constant from '../../../Utils/Constant';
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { GET_REPORT_USERS_ACTION } from '../../../Redux/Slices/ReportSlice/ReportSlice.action';
import AxiosInstance from '../../../Config/AxiosInstance';
import APILIST from '../../../Config/ApiList';
const ReportManagement = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [skip, setSkip] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [limit, setLimit] = useState(50);
    const [skip1, setSkip1] = useState(0);
    const [totalCount1, setTotalCount1] = useState(0);
    const [limit1, setLimit1] = useState(50);
    const [reportList, setReportList] = useState([]);
    const [jobReportList, setJobReportList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const columns = [
         {
            field: "action",
            headerName: "Action",
            minWidth: 50,
            filterable: false,
            editable: false,
            sortable: false,
            disableColumnMenu: true,
            renderCell: (params) => {
                const id = params?.row?.id;
                return (
                    <Tooltip title="View" key="view">
                        <IconButton
                            onClick={() => {
                                navigate(`/admin/reported-details`, {
                                    state: { id: id },
                                });
                            }
                            }
                            sx={{
                                width: "30px",
                                height: "30px",
                                borderRadius: "4px",
                                background:
                                    "linear-gradient(148.97deg, #0C2C50 0%, #450F5B 100%)",
                                "&:hover": {
                                    background:
                                        "linear-gradient(148.97deg, #0C2C50 0%, #450F5B 100%)",
                                },
                            }}
                        >
                            <RemoveRedEyeIcon sx={{ color: "#fff" }} />
                        </IconButton>
                    </Tooltip>
                );
            },
        },
        {
            field: "rowid",
            headerName: "Sr.No.",
            minWidth: 100,
            filterable: false,
            editable: false,
            sortable: false,
            disableColumnMenu: true,
        },
        {
            hideOnMobile: true,
            field: "profile_img",
            headerName: "Profile",
            minWidth: 50,
            filterable: false,
            editable: false,
            sortable: false,
            disableColumnMenu: true,
            renderCell: (params) => {
                return params?.row?.profile_img ? (
                    <img
                        src={`${Constant.BASE_URL}${params?.row?.profile_img}`}
                        alt="profile_photo"
                        style={{
                            width: "40px",
                            height: "40px",
                            borderRadius: "10px",
                        }}
                    />
                ) : (
                    <AccountCircleIcon sx={{ fontSize: "40px" }} />
                );
            },
        },
        {
            field: "full_name",
            headerName: "Full Name",
            minWidth: 250,
            filterable: true,
            sortable: true,
            flex: 1,
            renderCell: (params) => {
                const fullName = params?.row?.full_name || "--";
                return (
                    <Tooltip title={fullName?.length > 25 ? fullName : ""}>
                        <span>
                            {fullName?.length > 25
                                ? `${fullName?.substring(0, 25)}...`
                                : fullName}
                        </span>
                    </Tooltip>
                );
            },
        },
        {
            field: "report_count",
            headerName: "Report Count",
            minWidth: 250,
            filterable: false,
            editable: false,
            sortable: false,
            disableColumnMenu: true,
            renderCell: (params) => {
                const report_count = params?.row?.report_count || "--";
                return (
                    <span>
                        {report_count}
                    </span>
                );
            },
        },
       

    ];
    const columns1 = [
         {
            field: "action",
            headerName: "Action",
            minWidth: 50,
            filterable: false,
            editable: false,
            sortable: false,
            disableColumnMenu: true,
            renderCell: (params) => {
                const id = params?.row?.id;
                return (
                    <Tooltip title="View" key="view">
                        <IconButton
                            onClick={() => {
                                navigate(`/admin/job-reported-details`, {
                                    state: { id: id },
                                });
                            }
                            }
                            sx={{
                                width: "30px",
                                height: "30px",
                                borderRadius: "4px",
                                background:
                                    "linear-gradient(148.97deg, #0C2C50 0%, #450F5B 100%)",
                                "&:hover": {
                                    background:
                                        "linear-gradient(148.97deg, #0C2C50 0%, #450F5B 100%)",
                                },
                            }}
                        >
                            <RemoveRedEyeIcon sx={{ color: "#fff" }} />
                        </IconButton>
                    </Tooltip>
                );
            },
        },
        {
            field: "rowid",
            headerName: "Sr.No.",
            minWidth: 100,
            filterable: false,
            editable: false,
            sortable: false,
            disableColumnMenu: true,
        },
        {
            hideOnMobile: true,
            field: "profile_img",
            headerName: "Profile",
            minWidth: 50,
            filterable: false,
            editable: false,
            sortable: false,
            disableColumnMenu: true,
            renderCell: (params) => {
                return params?.row?.profile_img ? (
                    <img
                        src={`${Constant.BASE_URL}${params?.row?.profile_img}`}
                        alt="profile_photo"
                        style={{
                            width: "40px",
                            height: "40px",
                            borderRadius: "10px",
                        }}
                    />
                ) : (
                    <AccountCircleIcon sx={{ fontSize: "40px" }} />
                );
            },
        },
        {
            field: "full_name",
            headerName: "Full Name",
            minWidth: 250,
            filterable: true,
            sortable: true,
            flex: 1,
            renderCell: (params) => {
                const fullName = params?.row?.full_name || "--";
                return (
                    <Tooltip title={fullName?.length > 25 ? fullName : ""}>
                        <span>
                            {fullName?.length > 25
                                ? `${fullName?.substring(0, 25)}...`
                                : fullName}
                        </span>
                    </Tooltip>
                );
            },
        },
        {
            field: "title",
            headerName: "Title",
            minWidth: 250,
            filterable: true,
            sortable: true,
            flex: 1,
            renderCell: (params) => {
                const fullName = params?.row?.title || "--";
                return (
                    <Tooltip title={fullName?.length > 25 ? fullName : ""}>
                        <span>
                            {fullName?.length > 25
                                ? `${fullName?.substring(0, 25)}...`
                                : fullName}
                        </span>
                    </Tooltip>
                );
            },
        },
        {
            field: "report_count",
            headerName: "Report Count",
            minWidth: 250,
            filterable: false,
            editable: false,
            sortable: false,
            disableColumnMenu: true,
            renderCell: (params) => {
                const report_count = params?.row?.report_count || "--";
                return (
                    <span>
                        {report_count}
                    </span>
                );
            },
        },
        {
            field: "description",
            headerName: "Description",
            minWidth: 250,
            filterable: true,
            sortable: true,
            flex: 1,
            renderCell: (params) => {
                const fullName = params?.row?.description || "--";
                return (
                    <Tooltip title={fullName?.length > 25 ? fullName : ""}>
                        <span>
                            {fullName?.length > 25
                                ? `${fullName?.substring(0, 25)}...`
                                : fullName}
                        </span>
                    </Tooltip>
                );
            },
        },
       

    ];
    useEffect(() => {
        getAllReportList();
    }, [skip, limit, dispatch]);
    useEffect(() => {
        getJobReportList()
    }, [skip1, limit1, dispatch]);
    const getAllReportList = async () => {
        setIsLoading(true)
        await dispatch(GET_REPORT_USERS_ACTION({ skip, limit })).unwrap()
            .then((res) => {
                if (res && res?.s === 1) {
                    const Rowdata = res?.r?.map((data, i) => ({
                        rowid: i + 1 + skip * limit,
                        ...data,
                    }));
                    setIsLoading(false)
                    setReportList(Rowdata);
                    setTotalCount(res?.total || 0);
                } else {
                    setReportList([]);
                    setIsLoading(false)
                }
            }).catch((error) => {
                console.log('error', error);
                setIsLoading(false)
            })
    }
    const handlePageSizeChange = (newPageSize) => {
        setLimit(newPageSize);
        setSkip(0);
    };
    const handlePageChange = (newPage) => {
        setSkip(newPage);
    };
    const getJobReportList = async () => {
        try {
            const response = await AxiosInstance.get(APILIST.GET_ALL_JOB_REPORTS, {
                params: {
                    skip: skip1 * limit1,
                    limit: limit1,
                }
            })
            console.log('response', response)
            if (response && response?.data?.s === 1) {
                const Rowdata = response?.data?.r.map((data, i) => ({
                    rowid: i + 1 + skip * limit,
                    ...data,
                }));
                setJobReportList(Rowdata);
                setTotalCount(response?.data?.total || 0);
            } else {
                setJobReportList([]);
            }
        } catch (error) {
            console.error("Error fetching job report list:", error);

        }
    }
    const handlePageSizeChange1 = (newPageSize) => {
        setLimit1(newPageSize);
        setSkip1(0);
    };
    const handlePageChange1 = (newPage) => {
        setSkip1(newPage);
    };
    return (
        <>
            <Box
                sx={{
                    width: "100%",
                    bgcolor: "#fff",
                    padding: '10px'
                }}
            >
                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <Typography sx={{ fontSize: "24px", fontWeight: "500", fontFamily: 'Outfit', }}>
                            Report Management
                        </Typography>
                        <Box
                            sx={{
                                width: "100%",
                                paddingTop: "24px",
                            }}
                        >
                            <TableContainer
                                rows={reportList}
                                columns={columns}
                                loading={isLoading}
                                page={skip}
                                pageSize={limit}
                                totalCount={totalCount}
                                handlePageChange={handlePageChange}
                                onPageSizeChange={handlePageSizeChange}
                                paginationShow={true}
                            />
                        </Box>
                    </Grid>
                     <Grid item xs={12} md={6}>
                        <Typography sx={{ fontSize: "24px", fontWeight: "500", fontFamily: 'Outfit', }}>
                            Job Report Management
                        </Typography>
                        <Box
                            sx={{
                                width: "100%",
                                paddingTop: "24px",
                            }}
                        >
                            <TableContainer
                                rows={jobReportList}
                                columns={columns1}
                                loading={isLoading}
                                page={skip1}
                                pageSize={limit1}
                                totalCount={totalCount1}
                                handlePageChange={handlePageChange1}
                                onPageSizeChange={handlePageSizeChange1}
                                paginationShow={true}
                            />
                        </Box>
                    </Grid>
                </Grid>

            </Box>
        </>
    )
}

export default ReportManagement